import { useQuery } from '@tanstack/react-query';
import { rbacService } from '../../services/rbacService';

export const useRoles = () => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: () => rbacService.getAllRoles(),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const usePermissions = () => {
  return useQuery({
    queryKey: ['permissions'],
    queryFn: () => rbacService.getPermissions(),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const useUserRoles = (userId: string) => {
  return useQuery({
    queryKey: ['user-roles', userId],
    queryFn: () => rbacService.getUserRoles(userId),
    enabled: !!userId,
  });
};